export type BookingProviderType = "activities" | "transport" | "accommodation";

export interface BookingProvider {
  id: string;
  name: string;
  logo: string;
  type: BookingProviderType[];
  isComingSoon?: boolean;
  url?: string;
}

export const bookingProviders: BookingProvider[] = [
  {
    id: "booking",
    name: "Booking.com",
    logo: "@/assets/logos/external/booking-logo.svg",
    type: ["accommodation"],
    url: "https://booking.com",
  },
  {
    id: "plumguide",
    name: "Plum Guide",
    logo: "@/assets/logos/external/plum-guide-logo.svg",
    type: ["accommodation"],
    url: "https://plumguide.com",
  },
  {
    id: "agoda",
    name: "Agoda",
    logo: "@/assets/logos/external/agoda-logo.svg",
    type: ["accommodation"],
    url: "https://agoda.com",
  },
  {
    id: "viator",
    name: "Viator",
    logo: "@/assets/logos/external/viator-logo.svg",
    type: ["activities"],
    url: "https://viator.com",
  },
  {
    id: "kiwi",
    name: "Kiwi.com",
    logo: "@/assets/logos/external/kiwi-logo.svg",
    type: ["transport"],
    url: "https://kiwi.com",
  },
  {
    id: "waytora",
    name: "Waytora",
    logo: "@/assets/logos/internal/sidebar.svg",
    type: ["activities", "transport", "accommodation"],
    isComingSoon: true,
  },
];
